// react
import { createContext, Dispatch, SetStateAction } from 'react';

// defaults
import { defaultPagination } from '../../../utils/defaults';

// types
import {
	Account,
	AccountPayload,
	Act,
	Activity,
	Contract,
	Document,
	Entity,
	EntityPayload,
	Loan,
	Pagination,
	Permissions,
	IfrPlan,
	IfrPlanVersion,
	Project,
	Transaction,
	User,
	IfrPlanVersionPayload,
	Ifr,
	IfrPayload,
	IfrTables,
} from '../../../@types';

// accounts

export interface ContextAccountsDesignatedProps {
	accountsDesignated: Account[] | AccountPayload[];
	isLoadingAccountsDesignated: boolean;
	paginationAccountsDesignated: Pagination;
	refetchAccountsDesignated: () => void;
	setAccountsDesignated: Dispatch<SetStateAction<Account[] | AccountPayload[]>>;
	setPaginationAccountsDesignated: Dispatch<SetStateAction<Pagination>>;
}

export const ContextAccountsDesignated = createContext<ContextAccountsDesignatedProps>({
	accountsDesignated: [],
	isLoadingAccountsDesignated: false,
	paginationAccountsDesignated: defaultPagination,
	refetchAccountsDesignated: () => {
		console.log('REFETCH DESIGNATED ACCOUNTS');
	},
	setAccountsDesignated: () => {
		console.log('SET DESIGNATED ACCOUNTS');
	},
	setPaginationAccountsDesignated: () => {
		console.log('SET PAGINATION DESIGNATED ACCOUNTS');
	},
});

export interface ContextAccountsLocalProps {
	accountsLocal: Account[] | AccountPayload[];
	isLoadingAccountsLocal: boolean;
	paginationAccountsLocal: Pagination;
	refetchAccountsLocal: () => void;
	setAccountsLocal: Dispatch<SetStateAction<Account[] | AccountPayload[]>>;
	setPaginationAccountsLocal: Dispatch<SetStateAction<Pagination>>;
}

export const ContextAccountsLocal = createContext<ContextAccountsLocalProps>({
	accountsLocal: [],
	isLoadingAccountsLocal: false,
	paginationAccountsLocal: defaultPagination,
	refetchAccountsLocal: () => {
		console.log('REFETCH LOCAL ACCOUNTS');
	},
	setAccountsLocal: () => {
		console.log('SET LOCAL ACCOUNTS');
	},
	setPaginationAccountsLocal: () => {
		console.log('SET PAGINATION LOCAL ACCOUNTS');
	},
});

// acts

export interface ContextActsProps {
	acts: Act[];
	isLoadingActs: boolean;
	paginationActs: Pagination;
	refetchActs: () => void;
	setActs: Dispatch<SetStateAction<Act[]>>;
	setPaginationActs: Dispatch<SetStateAction<Pagination>>;
}

export const ContextActs = createContext<ContextActsProps>({
	acts: [],
	isLoadingActs: false,
	paginationActs: defaultPagination,
	setActs: () => {
		console.log('SET ACTS');
	},
	setPaginationActs: () => {
		console.log('SET PAGINATION');
	},
	refetchActs: () => {
		console.log('REFETCH ACTS');
	},
});

// activities

export interface ContextActivitiesProps {
	activities: Activity[];
	isLoadingActivities: boolean;
	paginationActivities: Pagination;
	refetchActivities: () => void;
	setActivities: Dispatch<SetStateAction<Activity[]>>;
	setPaginationActivities: Dispatch<SetStateAction<Pagination>>;
}

export const ContextActivities = createContext<ContextActivitiesProps>({
	activities: [],
	isLoadingActivities: false,
	paginationActivities: defaultPagination,
	refetchActivities: () => {
		console.log('REFETCH ACTIVITY');
	},
	setActivities: () => {
		console.log('SET ACTIVITIES');
	},
	setPaginationActivities: () => {
		console.log('SET PAGINATION ACTIVITIES');
	},
});

// contracts

export interface ContextContractsProps {
	contracts: Contract[];
	isLoadingContracts: boolean;
	paginationContracts: Pagination;
	refetchContracts: () => void;
	setContracts: Dispatch<SetStateAction<Contract[]>>;
	setPaginationContracts: Dispatch<SetStateAction<Pagination>>;
}

export const ContextContracts = createContext<ContextContractsProps>({
	isLoadingContracts: false,
	contracts: [],
	paginationContracts: defaultPagination,
	setContracts: () => {
		console.log('SET CONTRACTS');
	},
	setPaginationContracts: () => {
		console.log('SET PAGINATION');
	},
	refetchContracts: () => {
		console.log('REFETCH CONTRACTS');
	},
});

// entities

export interface ContextEntitiesProps {
	entities: Entity[] | EntityPayload[];
	isLoadingEntities: boolean;
	paginationEntities: Pagination;
	setEntities: Dispatch<SetStateAction<Entity[] | EntityPayload[]>>;
	setPaginationEntities: Dispatch<SetStateAction<Pagination>>;
	refetchEntities: () => void;
}

export const ContextEntities = createContext<ContextEntitiesProps>({
	entities: [],
	isLoadingEntities: false,
	paginationEntities: defaultPagination,
	setEntities: () => {
		console.log('SET ENTITIES');
	},
	setPaginationEntities: () => {
		console.log('SET PAGINATION');
	},
	refetchEntities: () => {
		console.log('REFETCH ENTITIES');
	},
});

// entities summary

export interface ContextEntitiesSummaryProps {
	entitiesSummary: Entity[];
	isLoadingEntitiesSummary: boolean;
	setEntitiesSummary: Dispatch<SetStateAction<Entity[]>>;
	refetchEntitiesSummary: () => void;
}

export const ContextEntitiesSummary = createContext<ContextEntitiesSummaryProps>({
	entitiesSummary: [],
	isLoadingEntitiesSummary: false,
	setEntitiesSummary: () => {
		console.log('SET ENTITIES');
	},
	refetchEntitiesSummary: () => {
		console.log('REFETCH ENTITIES');
	},
});

// loans

export interface ContextLoansProps {
	isLoadingLoans: boolean;
	loans: Loan[];
	paginationLoans: Pagination;
	setLoans: Dispatch<SetStateAction<Loan[]>>;
	refetchLoans: () => void;
}

export const ContextLoans = createContext<ContextLoansProps>({
	isLoadingLoans: false,
	loans: [],
	paginationLoans: defaultPagination,
	setLoans: () => {
		console.log('SET LOANS');
	},
	refetchLoans: () => {
		console.log('REFETCH LOANS');
	},
});

// operating expenses

export interface ContextOpExProps {
	isLoadingOpEx: boolean;
	paginationOpEx: Pagination;
	opEx: Transaction[];
	refetchOpEx: () => void;
	setPaginationOpEx: Dispatch<SetStateAction<Pagination>>;
	setOpEx: Dispatch<SetStateAction<Transaction[]>>;
}

export const ContextOpEx = createContext<ContextOpExProps>({
	isLoadingOpEx: false,
	paginationOpEx: defaultPagination,
	opEx: [],
	setOpEx: () => {
		console.log('SET OPEX');
	},
	setPaginationOpEx: () => {
		console.log('SET PAGINATION');
	},
	refetchOpEx: () => {
		console.log('REFETCH OPEX');
	},
});

// payments

export interface ContextPaymentsProps {
	isLoadingPayments: boolean;
	paginationPayments: Pagination;
	payments: Transaction[];
	refetchPayments: () => void;
	setPaginationPayments: Dispatch<SetStateAction<Pagination>>;
	setPayments: Dispatch<SetStateAction<Transaction[]>>;
}

export const ContextPayments = createContext<ContextPaymentsProps>({
	isLoadingPayments: false,
	paginationPayments: defaultPagination,
	payments: [],
	refetchPayments: () => {
		console.log('REFETCH PAYMENTS');
	},
	setPayments: () => {
		console.log('SET PAYMENTS');
	},
	setPaginationPayments: () => {
		console.log('SET PAGINATION');
	},
});

// reimbursements

export interface ContextReimbursementsProps {
	isLoadingReimbursements: boolean;
	paginationReimbursements: Pagination;
	refetchReimbursements: () => void;
	reimbursements: Transaction[];
	setReimbursements: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationReimbursements: Dispatch<SetStateAction<Pagination>>;
}

export const ContextReimbursements = createContext<ContextReimbursementsProps>({
	isLoadingReimbursements: false,
	paginationReimbursements: defaultPagination,
	refetchReimbursements: () => {
		console.log('REFETCH REIMBURSEMENTS');
	},
	reimbursements: [],
	setReimbursements: () => {
		console.log('SET REIMBURSEMENTS');
	},
	setPaginationReimbursements: () => {
		console.log('SET PAGINATION REIMBURSEMENTS');
	},
});

// advances

export interface ContextAdvancesProps {
	advances: Transaction[];
	isLoadingAdvances: boolean;
	paginationAdvances: Pagination;
	refetchAdvances: () => void;
	setAdvances: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationAdvances: Dispatch<SetStateAction<Pagination>>;
}

export const ContextAdvances = createContext<ContextAdvancesProps>({
	advances: [],
	isLoadingAdvances: false,
	paginationAdvances: defaultPagination,
	refetchAdvances: () => {
		console.log('REFETCH ADVANCES');
	},
	setAdvances: () => {
		console.log('SET ADVANCES');
	},
	setPaginationAdvances: () => {
		console.log('SET PAGINATION ADVANCES');
	},
});

// cash benefits

export interface ContextCashBenefitsProps {
	cashBenefits: Transaction[];
	isLoadingCashBenefits: boolean;
	paginationCashBenefits: Pagination;
	refetchCashBenefits: () => void;
	setCashBenefits: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationCashBenefits: Dispatch<SetStateAction<Pagination>>;
}

export const ContextCashBenefits = createContext<ContextCashBenefitsProps>({
	cashBenefits: [],
	isLoadingCashBenefits: false,
	paginationCashBenefits: defaultPagination,
	refetchCashBenefits: () => {
		console.log('REFETCH CASH BENEFITS');
	},
	setCashBenefits: () => {
		console.log('SET CASH BENEFITS');
	},
	setPaginationCashBenefits: () => {
		console.log('SET CASH BENEFITS');
	},
});

// non cash benefits

export interface ContextNonCashBenefitsProps {
	isLoadingNonCashBenefits: boolean;
	nonCashBenefits: Transaction[];
	paginationNonCashBenefits: Pagination;
	refetchNonCashBenefits: () => void;
	setNonCashBenefits: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationNonCashBenefits: Dispatch<SetStateAction<Pagination>>;
}

export const ContextNonCashBenefits = createContext<ContextNonCashBenefitsProps>({
	isLoadingNonCashBenefits: false,
	nonCashBenefits: [],
	paginationNonCashBenefits: defaultPagination,
	refetchNonCashBenefits: () => {
		console.log('REFETCH NON CASH BENEFITS');
	},
	setNonCashBenefits: () => {
		console.log('SET NON CASH BENEFITS');
	},
	setPaginationNonCashBenefits: () => {
		console.log('SET NON CASH BENEFITS');
	},
});

// transfers

export interface ContextTransfersProps {
	isLoadingTransfers: boolean;
	paginationTransfers: Pagination;
	transfers: Transaction[];
	refetchTransfers: () => void;
	setPaginationTransfers: Dispatch<SetStateAction<Pagination>>;
	setTransfers: Dispatch<SetStateAction<Transaction[]>>;
}

export const ContextTransfers = createContext<ContextTransfersProps>({
	isLoadingTransfers: false,
	paginationTransfers: defaultPagination,
	transfers: [],
	setTransfers: () => {
		console.log('SET TRANSFERS');
	},
	setPaginationTransfers: () => {
		console.log('SET PAGINATION');
	},
	refetchTransfers: () => {
		console.log('REFETCH TRANSFERS');
	},
});

// historical transactions

export interface ContextHistoricalTransactionsProps {
	isLoadingHistoricalTransactions: boolean;
	paginationHistoricalTransactions: Pagination;
	historicalTransactions: Document[];
	refetchHistoricalTransactions: () => void;
	setPaginationHistoricalTransactions: Dispatch<SetStateAction<Pagination>>;
	setHistoricalTransactions: Dispatch<SetStateAction<Document[]>>;
}

export const ContextHistoricalTransactions = createContext<ContextHistoricalTransactionsProps>({
	isLoadingHistoricalTransactions: false,
	paginationHistoricalTransactions: defaultPagination,
	historicalTransactions: [],
	setHistoricalTransactions: () => {
		console.log('SET HISTORICAL TRANSACTIONS');
	},
	setPaginationHistoricalTransactions: () => {
		console.log('SET PAGINATION');
	},
	refetchHistoricalTransactions: () => {
		console.log('REFETCH HISTORICAL TRANSACTIONS');
	},
});

// project

export interface ContextProjectProps {
	isLoadingProject: boolean;
	isOnboarded: boolean;
	project: Project | null;
	refetchProject: () => void;
	setProject: Dispatch<SetStateAction<Project | null>>;
}

export const ContextProject = createContext<ContextProjectProps>({
	isLoadingProject: false,
	isOnboarded: false,
	project: null,
	refetchProject: () => {
		console.log('REFETCH PROJECT');
	},
	setProject: () => {
		console.log('SET PROJECT');
	},
});

// suppliers

export interface ContextSuppliersProps {
	isLoadingSuppliers: boolean;
	paginationSuppliers: Pagination;
	setPaginationSuppliers: Dispatch<SetStateAction<Pagination>>;
	setSuppliers: Dispatch<SetStateAction<Entity[]>>;
	suppliers: Entity[];
	refetchSuppliers: () => void;
}

export const ContextSuppliers = createContext<ContextSuppliersProps>({
	isLoadingSuppliers: false,
	paginationSuppliers: defaultPagination,
	setPaginationSuppliers: () => {
		console.log('SET PAGINATION');
	},
	setSuppliers: () => {
		console.log('SET SUPPLIERS');
	},
	suppliers: [],
	refetchSuppliers: () => {
		console.log('REFETCH SUPPLIERS');
	},
});

// beneficiaries

export interface ContextBeneficiariesProps {
	isLoadingBeneficiaries: boolean;
	paginationBeneficiaries: Pagination;
	setPaginationBeneficiaries: Dispatch<SetStateAction<Pagination>>;
	setBeneficiaries: Dispatch<SetStateAction<Entity[]>>;
	beneficiaries: Entity[];
	refetchBeneficiaries: () => void;
}

export const ContextBeneficiaries = createContext<ContextBeneficiariesProps>({
	isLoadingBeneficiaries: false,
	paginationBeneficiaries: defaultPagination,
	setPaginationBeneficiaries: () => {
		console.log('SET PAGINATION');
	},
	setBeneficiaries: () => {
		console.log('SET BENEFICIARIES');
	},
	beneficiaries: [],
	refetchBeneficiaries: () => {
		console.log('REFETCH BENEFICIARIES');
	},
});

// documents suppliers
export interface ContextDocumentsSuppliersProps {
	isLoadingDocumentsSuppliers: boolean;
	paginationDocumentsSuppliers: Pagination;
	setPaginationDocumentsSuppliers: Dispatch<SetStateAction<Pagination>>;
	setDocumentsSuppliers: Dispatch<SetStateAction<Document[]>>;
	documentsSuppliers: Document[];
	refetchDocumentsSuppliers: () => void;
}

export const ContextDocumentsSuppliers = createContext<ContextDocumentsSuppliersProps>({
	isLoadingDocumentsSuppliers: false,
	paginationDocumentsSuppliers: defaultPagination,
	setPaginationDocumentsSuppliers: () => {
		console.log('SET PAGINATION');
	},
	setDocumentsSuppliers: () => {
		console.log('SET DOCUMENTS');
	},
	documentsSuppliers: [],
	refetchDocumentsSuppliers: () => {
		console.log('REFETCH DOCUMENTS');
	},
});

// documents beneficiaries
export interface ContextDocumentsBeneficiariesProps {
	isLoadingDocumentsBeneficiaries: boolean;
	paginationDocumentsBeneficiaries: Pagination;
	setPaginationDocumentsBeneficiaries: Dispatch<SetStateAction<Pagination>>;
	setDocumentsBeneficiaries: Dispatch<SetStateAction<Document[]>>;
	documentsBeneficiaries: Document[];
	refetchDocumentsBeneficiaries: () => void;
}

export const ContextDocumentsBeneficiaries = createContext<ContextDocumentsBeneficiariesProps>({
	isLoadingDocumentsBeneficiaries: false,
	paginationDocumentsBeneficiaries: defaultPagination,
	setPaginationDocumentsBeneficiaries: () => {
		console.log('SET PAGINATION');
	},
	setDocumentsBeneficiaries: () => {
		console.log('SET DOCUMENTS');
	},
	documentsBeneficiaries: [],
	refetchDocumentsBeneficiaries: () => {
		console.log('REFETCH DOCUMENTS');
	},
});

// users with permissions
export interface ContextUsersPermissionsProps {
	isLoadingUsersPermissions: boolean;
	paginationUsersPermissions: Pagination;
	setPaginationUsersPermissions: Dispatch<SetStateAction<Pagination>>;
	setUsersPermissions: Dispatch<SetStateAction<User[]>>;
	refetchUsersPermissions: () => void;
	usersPermissions: User[];
}

export const ContextUsersPermissions = createContext<ContextUsersPermissionsProps>({
	isLoadingUsersPermissions: false,
	paginationUsersPermissions: defaultPagination,
	setPaginationUsersPermissions: () => {
		console.log('SET PAGINATION');
	},
	setUsersPermissions: () => {
		console.log('SET USERS WITH PERMISSIONS');
	},
	refetchUsersPermissions: () => {
		console.log('REFETCH USERS WITH PERMISSIONS');
	},
	usersPermissions: [],
});

export interface ContextUserProjectPermissionsProps {
	userProjectPermissions: Permissions;
}

export const ContextUserProjectPermissions = createContext<ContextUserProjectPermissionsProps>({
	userProjectPermissions: {},
});

// ifrs
export interface ContextIfrsProps {
	ifrs: Ifr[];
	isLoadingIfrs: boolean;
	paginationIfrs: Pagination;
	refetchIfrs: () => void;
	setIfrs: Dispatch<SetStateAction<Ifr[]>>;
	setPaginationIfrs: Dispatch<SetStateAction<Pagination>>;
}

export const ContextIfrs = createContext<ContextIfrsProps>({
	ifrs: [],
	isLoadingIfrs: false,
	paginationIfrs: defaultPagination,
	refetchIfrs: () => {
		console.log('REFETCH IFR REPORTS');
	},
	setIfrs: () => {
		console.log('SET IFR REPORTS');
	},
	setPaginationIfrs: () => {
		console.log('SET PAGINATION');
	},
});

// ifr plans
export interface ContextIfrPlansProps {
	ifrPlans: IfrPlan[];
	isLoadingIfrPlans: boolean;
	paginationIfrPlans: Pagination;
	refetchIfrPlans: () => void;
	setIfrPlans: Dispatch<SetStateAction<IfrPlan[]>>;
	setPaginationIfrPlans: Dispatch<SetStateAction<Pagination>>;
}

export const ContextIfrPlans = createContext<ContextIfrPlansProps>({
	ifrPlans: [],
	isLoadingIfrPlans: false,
	paginationIfrPlans: defaultPagination,
	refetchIfrPlans: () => {
		console.log('REFETCH IFR PLANS');
	},
	setIfrPlans: () => {
		console.log('SET IFR PLANS');
	},
	setPaginationIfrPlans: () => {
		console.log('SET PAGINATION');
	},
});

// ifr plan
export interface ContextIfrPlanProps {
	ifrPlan: IfrPlan | null;

	isLoadingIfrPlan: boolean;
	refetchIfrPlan: () => void;
	setIfrPlan: Dispatch<SetStateAction<IfrPlan | null>>;
}

export const ContextIfrPlan = createContext<ContextIfrPlanProps>({
	ifrPlan: null,

	isLoadingIfrPlan: false,
	refetchIfrPlan: () => {
		console.log('REFETCH IFR PLAN');
	},
	setIfrPlan: () => {
		console.log('SET IFR PLAN');
	},
});

// ifr plan version
export interface ContextIfrPlanVersionProps {
	ifrPlanVersion: IfrPlanVersion | null;
	ifrPlanVersionPayload: IfrPlanVersionPayload | null;
	setIfrPlanVersion: Dispatch<SetStateAction<IfrPlanVersion | null>>;
	setIfrPlanVersionPayload: Dispatch<SetStateAction<IfrPlanVersionPayload | null>>;
}

export const ContextIfrPlanVersion = createContext<ContextIfrPlanVersionProps>({
	ifrPlanVersion: null,
	ifrPlanVersionPayload: null,
	setIfrPlanVersion: () => {
		console.log('SET IFR PLAN VERSION');
	},
	setIfrPlanVersionPayload: () => {
		console.log('SET IFR PLAN VERSION PAYLOAD');
	},
});

// ifr
export interface ContextIfrProps {
	ifr: Ifr | null;
	ifrPayload: IfrPayload | null;
	ifrTables: IfrTables;
	isLoadingIfr: boolean;
	refetchIfr: () => void;
	setIfr: Dispatch<SetStateAction<Ifr | null>>;
	setIfrPayload: Dispatch<SetStateAction<IfrPayload | null>>;
	setIfrTables: Dispatch<SetStateAction<IfrTables>>;
}

export const ContextIfr = createContext<ContextIfrProps>({
	ifr: null,
	ifrPayload: null,
	ifrTables: {},
	isLoadingIfr: false,
	refetchIfr: () => {
		console.log('REFETCH IFR');
	},
	setIfr: () => {
		console.log('SET IFR');
	},
	setIfrPayload: () => {
		console.log('SET IFR PAYLOAD');
	},
	setIfrTables: () => {
		console.log('SET IFR TABLES');
	},
});
